
import { defineComponent, computed, defineExpose } from "vue";
// Ajusta la ruta al modelo real de Teachers
import type { ITeachersModel } from "@/interfaces/modules/aula/ITeachersModel";

export default defineComponent({
  name: "TabHealthTeacher",
  props: {
    record: { type: Object as () => ITeachersModel, required: true },
    wasValidated: { type: Boolean, default: false }
  },
  emits: ["update:record"],
  setup(props, { emit }) {
    const recordProxy = computed<ITeachersModel>({
      get: () => props.record,
      set: (val) => emit("update:record", val),
    });

    const updateField = (key: keyof ITeachersModel, value: any) => {
      recordProxy.value = { ...recordProxy.value, [key]: value };
    };

    const validate = () => ({ ok: true });
    defineExpose({ validate });

    return { recordProxy, updateField };
  },
});
